<template>
  <div class="t_header" style="z-index: 2;">
    <div class="left" @click="goBack">
      <div class="icon"></div>
    </div>
    <div class="tq-title" v-if="title">{{ title }}</div>
    <div class="center">
      <slot name="center" />
    </div>
    <div class="right">
      <slot name="right" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'THeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    toUrl: {
      type: String,
      default: ''
    },
    back: {
      type: Function,
      default: function () { }
    }
  },
  data() {
    return {}
  },
  methods: {
    goBack() {
      if (this.toUrl) {
        this.$router.push({ path: this.toUrl })
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.t_header {
  .tq-title {
    font-weight: 800;
    font-size: 16px;
  }
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #fff;
  font-size: 20px;
  color: #000;
  text-align: center;
  border-bottom: 1px solid #eee;
  .left {
    position: absolute;
    height: 100%;
    width: 140px;
    z-index: 999999;
    .icon {
      position: relative;
      top: 18px;
      left: 20px;
      width: 12px;
      height: 12px;
      border-top: 3px solid #000000;
      border-right: 3px solid #000000;
      transform: rotate(-135deg);
    }
  }
  .right {
    position: absolute;
    top: 0;
    right: 20px;
    z-index: 999999;
  }
  .center {
    font-size: 18px;
    & > div {
      height: 100%;
    }
  }
}
</style>
